
import { Vue, Component, Prop } from 'vue-property-decorator'
import { NamedItem } from './DbChip.vue'

@Component
export default class DbSelectedChips extends Vue {
  @Prop() items!: NamedItem[];
}
